function makeOptions(data = {}) {
  return {
    method: 'post',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-Parse-Application-Id': 'ta8PxnPFEQGLQNH5GncBDf4rj42rWKTyckM7YBoc',
    },
    body: JSON.stringify(data)
  };
}

export default makeOptions;



// WEBPACK FOOTER //
// ./src/utils/makeFetchOptions.js